/**
 * T10 mini oven — match live layout/interaction:
 * wrap dec sections, reveal heating-element copy, switch cooking modes.
 */
(function () {
  const DECO_IMAGES = `
    <img class="dec-img1" src="https://cdn.shopify.com/s/files/1/0596/8006/3675/files/image_33.png?v=1692599213" alt="">
    <img class="dec-img2" src="https://cdn.shopify.com/s/files/1/0596/8006/3675/files/image_32.png?v=1692599247" alt="">
    <img class="dec-img3" src="https://cdn.shopify.com/s/files/1/0596/8006/3675/files/7688781_1.png?v=1692599281" alt="">
    <img class="dec-img4" src="https://cdn.shopify.com/s/files/1/0596/8006/3675/files/3348059_1.png?v=1692599281" alt="">
    <img class="dec-img5" src="https://cdn.shopify.com/s/files/1/0596/8006/3675/files/41.png?v=1692599314" alt="">
  `;

  function wrapOvenDec() {
    if (document.querySelector('.product-oven-dec')) return;

    const findSection = (handle) =>
      document.getElementById(`shopify-section-${handle}`) ||
      document.querySelector(`[id$="${handle}"]`);

    const sections = ['product-oven-dec1', 'product-oven-dec2', 'product-oven-dec3']
      .map(findSection)
      .filter(Boolean);
    if (sections.length < 2) return;

    const wrap = document.createElement('div');
    wrap.className = 'product-oven-dec';
    sections[0].parentNode.insertBefore(wrap, sections[0]);
    sections.forEach((section) => wrap.appendChild(section));
    wrap.insertAdjacentHTML('beforeend', DECO_IMAGES);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wrapOvenDec);
  } else {
    wrapOvenDec();
  }
})();

if (!customElements.get('oven-floating-intro')) {
  class OvenFloatingIntro extends HTMLElement {
    connectedCallback() {
      const text = this.querySelector('.oven-floating-text');
      if (!text) return;

      const reveal = () => text.classList.add('oven-floating-text-animate');
      const fallback = window.setTimeout(reveal, 1200);

      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(
          (entries) => {
            if (entries.some((entry) => entry.isIntersecting)) {
              window.clearTimeout(fallback);
              reveal();
              io.disconnect();
            }
          },
          { threshold: 0.2, rootMargin: '0px 0px -10% 0px' }
        );
        io.observe(this);
      } else {
        window.clearTimeout(fallback);
        reveal();
      }
    }
  }

  customElements.define('oven-floating-intro', OvenFloatingIntro);
}

if (!customElements.get('oven-function-switch')) {
  class OvenFunctionSwitch extends HTMLElement {
    connectedCallback() {
      this.tabs = this.querySelectorAll('[data-oven-tab]');
      this.panels = this.querySelectorAll('[data-oven-panel]');

      this.addEventListener('click', (event) => {
        const tab = event.target.closest('[data-oven-tab]');
        if (!tab || !this.contains(tab)) return;
        this.select(tab.dataset.ovenTab);
      });

      this.select(this.tabs[0]?.dataset.ovenTab || '1');
      this._tries = 0;
      this._initMobileSwiper();
    }

    disconnectedCallback() {
      this.swiper?.destroy?.(true, true);
      this.swiper = null;
    }

    select(index) {
      if (!index) return;

      this.tabs.forEach((tab) => {
        const on = tab.dataset.ovenTab === index;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-pressed', on ? 'true' : 'false');
        const fill = tab.querySelector('svg > path:first-child');
        if (fill) fill.style.opacity = on ? '1' : '0';
      });

      this.panels.forEach((panel) => {
        const on = panel.dataset.ovenPanel === index;
        panel.classList.toggle('is-active', on);
        panel.hidden = !on;
        panel.style.opacity = on ? '1' : '0';
        panel.querySelectorAll('video').forEach((video) => {
          if (on) {
            video.play?.().catch(() => {});
          } else {
            video.pause?.();
          }
        });
      });
    }

    _initMobileSwiper() {
      const root = this.querySelector('.oven-icon-list-mobile');
      if (!root || !root.querySelector('.swiper-wrapper')) return;
      if (window.innerWidth >= 678) return;

      if (typeof Swiper !== 'function') {
        this._tries = (this._tries || 0) + 1;
        if (this._tries > 80) return;
        window.setTimeout(() => this._initMobileSwiper(), this._tries < 10 ? 0 : 25);
        return;
      }

      this.swiper = new Swiper(root, {
        slidesPerView: 5,
        slidesPerGroup: 1,
        spaceBetween: 21,
        observer: true,
        observeParents: true,
        watchOverflow: true,
        scrollbar: {
          el: this.querySelector('.swiper-scrollbar-oven'),
          draggable: true,
        },
      });
    }
  }

  customElements.define('oven-function-switch', OvenFunctionSwitch);
}
